import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export const ListenForUnrealVMMessages = async (userId, callback) => {
	//first we need to ignore any excess messages

	console.log('userIdjisvhnwediv', userId);
	let ignoreVariable = '';
	await firebase
		.database()
		.ref('/users/' + userId + '/unrealMessages')
		.once('value', (snapshot) => {
			let unrealMessagesObj = snapshot.val();
			var allKeys = Object.keys(unrealMessagesObj);

			console.log('This si the afalfc', allKeys);

			if (allKeys?.length > 0) {
				ignoreVariable = allKeys[allKeys.length - 1];
			}
		});

	firebase
		.database()
		.ref('/users/' + userId + '/unrealMessages')
		.on('value', async (snapshot) => {
			//do a thin
			let unrealMessagesObj = snapshot.val();

			var allKeys = unrealMessagesObj && Object.keys(unrealMessagesObj);
			var newKey = allKeys && allKeys[allKeys?.length - 1];
			if (newKey != ignoreVariable) {
				callback();
			}
			//for now theres only one thing

			ignoreVariable = newKey;
		});
};
